export default __webpack_public_path__ + "static/media/login-bg.909bd465.png";